

<template v-if="
    locationsStore.allLocations.length > 1
">
    <div class="mb-1.5 border-b border-gray-300 pb-1.5">
        <h2 class="h6">
            By Location
        </h2>
        <VueMultiselect
            v-model="locationsStore.selectedLocations"
            :options="locationsStore.allLocations"
            :multiple="true"
            :prevent-autofocus="true"
            label="name"
            track-by="id"
            placeholder="Type a location name..."
            @select="onSelect"
            @remove="onRemove"
        >
        </VueMultiselect>
    </div>
</template>

